// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { InvoiceItemPaymentRequest } from './invoice-item-payment-request';

// @ts-ignore
import { ReceivePaymentTransferInvoiceItemsRequest } from './receive-payment-transfer-invoice-items-request';

/** See com.rev360.pms.api.controller.accounting.payment.CreatePaymentRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePaymentRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Amount is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	amount!: number;

	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

	@GandalfArray(InvoiceItemPaymentRequest)
	paymentItems!: InvoiceItemPaymentRequest[];

	@GandalfArray(ReceivePaymentTransferInvoiceItemsRequest)
	paymentTransfers!: ReceivePaymentTransferInvoiceItemsRequest[];

}
